import script from "./PartnerProjectFormStep8.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerProjectFormStep8.vue?vue&type=script&setup=true&lang=js"

import "./PartnerProjectFormStep8.vue?vue&type=style&index=0&id=2135b9a8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2135b9a8"]])

export default __exports__